import {
    TOP_NETWORK_LANES_REQUEST,
    TOP_NETWORK_LANES_SUCCESS,
    TOP_NETWORK_LANES_FAILURE
} from '../../actions/networkInsights/topNetworkLanesActions';

interface TopNetworkLanes {
    topNetworkLanes: any;
    isFetching: boolean;
}

const fetchTopLanesReducer = (topNetworkLanesData: TopNetworkLanes = {
    isFetching: false,
    topNetworkLanes: {}
}, action: any): TopNetworkLanes => {
    switch (action.type) {
        case TOP_NETWORK_LANES_REQUEST: {
            return {
                ...topNetworkLanesData,
                isFetching: true
            };
        }
        case TOP_NETWORK_LANES_SUCCESS: {
            return {
                isFetching: false,
                topNetworkLanes: action.payload
            };
        }
        case TOP_NETWORK_LANES_FAILURE: {
            return {
                isFetching: false,
                topNetworkLanes: {}
            };
        }
        default:
            return topNetworkLanesData;
    }
};

export default fetchTopLanesReducer;
